import { TrendUp, TrendDown } from "@phosphor-icons/react";

/* ============================================================================
 * ComparisonSection — this week vs last week for the 4 core metrics.
 * ==========================================================================*/
export function ComparisonSection({ comparison }) {
  if (!comparison) return null;
  const rows = [
    { key: "installs", label: "Installs (Apple)", data: comparison.installs },
    { key: "download_clicks", label: "App Store link clicks", data: comparison.download_clicks },
    { key: "page_views", label: "Page views", data: comparison.page_views },
    { key: "signups", label: "Newsletter signups", data: comparison.signups },
  ];

  return (
    <section
      className="border border-white/10 bg-[#0a0a0a] p-6"
      data-testid="admin-comparison"
    >
      <div className="flex items-baseline justify-between mb-5">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-1">
            // this week vs last week
          </div>
          <h3 className="font-display text-xl font-extrabold tracking-tight">
            Momentum check
          </h3>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/45">
          last 7 days · vs 7 days before that
        </span>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {rows.map(({ key, label, data }) => {
          const pct = data?.pct;
          const up = pct !== null && pct !== undefined && pct >= 0;
          const flat = pct === null || pct === undefined || pct === 0;
          const color = flat ? "text-white/45" : up ? "text-emerald-400" : "text-[#FF2A2A]";
          const Icon = flat ? null : up ? TrendUp : TrendDown;
          return (
            <div
              key={key}
              data-testid={`compare-${key}`}
              className="border border-white/10 bg-black p-5"
            >
              <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-white/45 mb-3">
                {label}
              </div>
              <div className="flex items-baseline gap-3">
                <div className="font-display text-3xl font-extrabold tracking-tight text-white">
                  {(data?.this ?? 0).toLocaleString()}
                </div>
                <div className={`inline-flex items-center gap-1 font-mono text-xs ${color}`}>
                  {Icon && <Icon size={12} weight="bold" />}
                  {pct === null || pct === undefined ? "—" : `${up ? "+" : ""}${pct}%`}
                </div>
              </div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                prev · {(data?.last ?? 0).toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
